import type { Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { unref } from 'vue';
import { getApi } from './api';
import type {
  AccountExceptionsListParams,
  ShipmentExceptionRow,
} from './shipment-exception-types';

export type {
  AccountExceptionsListParams,
  ShipmentExceptionRow,
} from './shipment-exception-types';

type Paginated = {
  data: ShipmentExceptionRow[];
  meta?: { total?: number; current_page?: number; per_page?: number };
};

export default (
  accountId: Ref<number> | number,
  params: Ref<AccountExceptionsListParams> | AccountExceptionsListParams = {},
) => {
  return useQuery({
    queryKey: [
      'account-exceptions',
      () => unref(accountId),
      () => unref(params),
    ],
    queryFn: async (): Promise<Paginated> => {
      const { api, baseURL } = getApi();
      const actualAccountId = unref(accountId);
      const p = unref(params) ?? {};
      const res = await api.get(`/api/v2/accounts/${actualAccountId}/exceptions`, {
        baseURL,
        params: p,
      });
      const body = res.data;
      return {
        data: (body?.data ?? []) as ShipmentExceptionRow[],
        meta: body?.meta,
      };
    },
    enabled: !!unref(accountId),
  });
};
